/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
import { formatDistance } from 'date-fns';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { connect } from 'react-redux';
import {
  Col,
  Button,
  Dropdown,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import {
  editAssignedNumber,
  getPortCallHistory,
  getObiSystemStatus,
  portConfig,
  getPortValues,
  getAssignedNumbers,
  selectBoxDetailsPort,
  getEpikBoxData,
  trunkPortConfig,
  getPhysicalStatus,
  obiRebootRequired,
  boundForwardNumber,
  boundRemoveNumber,
  enableDisablePort,
  updateAlarmProtocol,
  updateEpikBoxObi,
  addNote,
  removeAlarmProtocolSettings,
  updateAdvanceModemConfigurations,
  getSelectedPortModal,
  updateNumberRouteAndTrunk,
} from '../../../actions/EpikBoxes';
import {
  cancelAddNumber,
  editNumberCancel,
  updateNumber,
  forceFixNumber,
  getNumberByID,
  getAlarmRelay,
} from '../../../actions/Numbers';
import * as ProvisioningActions from '../../../actions/Provisioning';
import {
  assignRouteInfo,
  getAddress,
  getGateways,
  updateAddress,
} from '../../../actions/Provisioning';
import DeleteModal from '../../DeleteModal';
import AddBoxNumberModal from './AddBoxNumberModal';
import EditBoxNumberModal from './EditBoxNumberModal';
import PortProperty from './PortProperty';
import './selectedPortPanel.css';
import PortConfigModal from './PortConfigModal';
import getObiData from '../../../containers/epikBoxes/helpers';
import SpinnerCircles from '../../Spinner/SpinerCircles';
import Spinner from '../../Spinner/Spinner';
import DropdownSelect, { findSelectedOption } from '../../ProposalGenerator/DropdownSelect';
import { arrayType, evenValues, oddValues, trunkOptions } from '../constants';
import {
  assignAction,
  sendBulkActionsToApi,
  unassignAction,
  enableAction,
  disableAction,
} from '../../../actions/BoxSessionLogging';
import AddSecurityCodeModal from '../../AddSecurityCodeModal';
import CustomModal from '../../CustomModal';
import ForwardNumber from '../../form/ForwardNumber';
import utils from '../../../lib/utils';
import Toggle from '../../Toggle';
import E911AddressModal from '../../E911AddressModal';
import ConfirmationModal from '../../ConfirmationModal';
import { TOOLTIPS_TEXT, PENDING_FAX_AVAILABLE } from '../../../lib/constants';
import InfoPopup from '../../InfoPopup';
import ActivateButton from './ActivateButton';
import { isAdminRole } from '../../../lib/utils';

const eDisableEnableAction = {
  ENABLE: 'enable',
  DISABLE: 'disable',
};

const PORT_IS_REBOOTING = 'Please wait 3 minutes while port is rebooting';

const DEFAULT_VALID_TIME_FOR_ENABLE_DISABLE_PORT = 3;

const CONFIRMATION_MODAL_BODY =
  'Disabling the port will require a reboot of the ATA and service will be interupted on both ports. After reboot this port will be disabled. Are you sure you want to continue?';

const CONFIRMATION_TYPE_CHANGE = `WARNING: Changing the line type will remove APR settings from this port. Do you wish to continue?`;
class SelectedPortPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editingProperty: null,
      showModal: false,
      showError: false,
      isLoading: false,
      portModal: props.showPortDetail,
      showEditModal: false,
      selectedNumber: '',
      modalStatus: false,
      showHistoryModal: false,
      historyPortCall: [],
      selectedNumberId: null,
      portObiSystemList: [],
      loadingConfig: false,
      settings: [],
      assignedE911Number: false,
      settingsValidationRules: [],
      securityCheck: false,
      selectedValue: '',
      wrongSecurityCode: '',
      trunkOptions:
        props.port?.assignedNumberRef?.trunkSelection &&
          props.port?.assignedNumberRef?.trunkSelection !== '1'
          ? trunkOptions.filter(item => item.value !== '1')
          : trunkOptions,
      selectedTrunkOption: findSelectedOption(
        {
          value: props.port?.assignedNumberRef?.trunkSelection,
        },
        trunkOptions,
      ),
      fwdModalState: false,
      fwdNumber: props.port?.assignedNumberRef?.isForwarded
        ? props.port?.assignedNumberRef?.forwardNumbers[0]
        : '+1',
      fwdCheck: !props.port?.assignedNumberRef?.isForwarded,
      portBtnLoading: false,
      portPhysicalData: {},
      monitor: props.port?.monitored || false,
      outbound: props.port?.forceForward || false,
      disabled: props.port?.disabled || false,
      enableDisableLastUpdatedTime: props.port?.enableDisableLastUpdatedTime || false,
      warningModal: false,
      isEnableDisablePortSecurity: false,
      outboundNumber: props.port?.forceForwardNumber || '',
      outboundNumberBtnLoading: false,
      historyStatus: true,
      forceFix: false,
      alarmProtocol: null,
      alarmRelay: null,
      loadingApr: false,
      modifyStatus: false,
      addNote,
      previousType: null,
      typeChangeWarning: false,
      selectedTrunkLabe: null,
      portEnableDisableToggle: null,
      portRebot: false,
    };

    const lastUpdatedDistanceValue = lastUpdated => {
      return lastUpdated
        ? formatDistance(new Date(), new Date(lastUpdated), { addSuffix: true })
        : '-';
    };

    const e911NumberValue = e911Number => !!e911Number;

    this.portDetailsProps = [
      {
        key: 'boxPortNumber',
        prop: 'boxPortNumber',
        label: 'Port Number',
        icon: 'hashtag',
        editable: false,
        hidden: false,
      },
      {
        key: 'portLabel',
        prop: 'portLabel',
        label: 'Port Label',
        icon: 'hashtag',
        value: () => props.port?.assignedNumberRef?.portLabel || 'No Port Label',
        editable: false,
        hidden: false,
      },
      {
        key: 'lastUpdated',
        prop: 'lastUpdated',
        label: 'Last Updated',
        icon: 'clock',
        editable: false,
        value: lastUpdatedDistanceValue,
        hidden: false,
      },
      {
        key: 'assignedNumber',
        prop: 'assignedNumber',
        label: 'Assigned Number',
        icon: 'hashtag',
        editable: true,
        hidden: false,
      },
      {
        key: 'e911Number',
        prop: 'e911Number',
        label: 'E911 Number',
        editable: true,
        value: e911NumberValue,
        hidden: !props?.boxDetails?.myEpik || false,
      },
    ];
    this.boxRef = React.createRef();
    this.updatedPort = '';
    this.editRouteReq = {
      token: null,
    };
    this.token = localStorage.getItem('jwtToken') || null;
  }

  async componentDidMount() {
    const { getGateways, user, port } = this.props;
    this.setState({ loadingApr: true });
    this.onPortStatus();
    this.onAssignedNumber();
    this.onObiSystemStatus();

    if (
      user.role === 'superAdmin' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager' ||
      user.role === 'supportEngineer'
    ) {
      await getGateways(this.token);
    }
    this.checkHistoryStatus();
  }

  componentDidUpdate(prevProps) {
    const { numbers, port } = this.props;
    if (numbers && prevProps.numbers !== numbers && port?.e911Enabled) {
      this.getNumberAddress();
    }
  }

  // eslint-disable-next-line react/sort-comp
  getNumberAddress = () => {
    const { numbers, port, getAddress } = this.props;
    const numbersDB = numbers?.allNumbers?.length ? numbers?.allNumbers : [numbers?.numberByID]
    const numberDetails = numbersDB?.filter(item => {
      let portNumber = port?.assignedNumber;
      let number = item?.number;
      if (!portNumber?.includes('+1')) portNumber = '+1' + portNumber;
      if (!number?.includes('+1')) number = '+1' + number;
      return portNumber === number;
    });

    this.setState({ selectedNumberId: numberDetails?.[0]?._id });
    if (numberDetails?.[0]?._id) {
      getAddress(this.token, numberDetails?.[0]?._id);
    }
  };

  // eslint-disable-next-line react/sort-comp
  checkHistoryStatus = () => {
    const { port } = this.props;
    const { assignedNumberRef } = port;
    if (assignedNumberRef) {
      if (!!port.assignedNumber?.number || port.assignedNumber?.number !== 'N/A') {
        this.setState({
          historyStatus: false,
        });
      } else {
        this.setState({
          historyStatus: true,
        });
      }
    } else {
      this.setState({
        historyStatus: true,
      });
    }
  };

  onPortStatus = async () => {
    this.setState({ portBtnLoading: true });
    const { getPhysicalStatus, port, boxDetails, getNumberByID, getAlarmRelay } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId =
      boxDetails?.Obis?.length === 1 ? boxDetails?.Obis[0]?._id : boxDetails?.Obis[checkObi]?._id;
    if (
      port?.assignedNumberRef?.type === 'fireAlarm' ||
      port?.assignedNumberRef?.type === 'alarm'
    ) {
      this.setState({ modifyStatus: true });
      await getAlarmRelay(this.token, boxDetails._id, portNumber);
    }

    let selectedNum = {};
    if (port.assignedNumberRef?._id) {
      selectedNum = await getNumberByID(this.token, port.assignedNumberRef?._id);
    }
    this.setState({ modifyStatus: false });
    const portPhysical = await getPhysicalStatus(this.token, obiId, portNumber);

    let portEnableDisableToggle = this.state.portEnableDisableToggle
    let portRebot = this.state.portRebot
    if (portEnableDisableToggle == null) {
      portEnableDisableToggle = portPhysical.disabled
    }
    else if (!portEnableDisableToggle && !portPhysical.State) {
      portRebot = true
    }
    else {
      portRebot = false
    }
    this.setState({
      loadingApr: false,
      portBtnLoading: false,
      portPhysicalData: portPhysical,
      alarmRelay: selectedNum?.alarmRelayInfo,
      portEnableDisableToggle,
      portRebot
    });
  };

  componentWillReceiveProps(props) {
    const { onConfigResp } = props;
    if (onConfigResp !== null) {
      this.setState({ showError: true });
      this.setState({ isLoading: false });
    } else {
      this.setState({ showError: false });
    }
  }

  onAssignedNumber = async () => {
    const { boxDetails, getAssignedNumbers } = this.props;
    await getAssignedNumbers(
      this.token,
      boxDetails.assignedTo?._id,
      boxDetails.epikBoxUser?._id,
      false,
    );
  };

  confirmCheck = async () => {
    const {
      port,
      boxDetails,
      getEpikBoxData,
      trunkPortConfig,
      onOutsideClick,
      addNote
    } = this.props;
    const { selectedTrunkOption, selectedTrunkLabel } = this.state;

    this.setState({ securityCheck: false });
    const trunkResp = await trunkPortConfig(this.token, {
      vpnAddress: boxDetails?.vpnAddress,
      selectedPort: port?.boxPortNumber
        .split(' ')
        .join('')
        .toLowerCase(),
      number: { ...port?.assignedNumberRef, trunkSelection: selectedTrunkOption },
    });

    if (trunkResp) {
      const obj = {
        note: `Trunk selection updated to ${selectedTrunkLabel} on ${port?.boxPortNumber}`,
        type: 'system',
      };
  
      addNote(this.token, boxDetails._id, obj);
    }
    getEpikBoxData(this.token, boxDetails?._id);
    onOutsideClick();
  };

  onForceFixBtn = async () => {
    const { forceFixNumber, boxDetails, port } = this.props;
    await forceFixNumber(this.token, port?.assignedNumberRef?._id, boxDetails?._id);
  };

  onObiSystemStatus = async () => {
    this.setState({ isLoading: true });
    const { getObiSystemStatus, port, boxDetails } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const obiStatus = await getObiSystemStatus(this.token, boxDetails?._id, portNumber);
    const obiStatusArray =
      typeof obiStatus?.portObiSystemStatus === 'object'
        ? Object.keys(obiStatus?.portObiSystemStatus)
        : [];
    const newPortObiArray = [];
    obiStatusArray?.length > 0 &&
      obiStatusArray.map(item => {
        if (portNumber % 2 === 0) {
          if (item !== 'sp1ServiceStatus') {
            newPortObiArray.push(obiStatus?.portObiSystemStatus[item]);
          }
        } else if (item !== 'sp2ServiceStatus') {
          newPortObiArray.push(obiStatus?.portObiSystemStatus[item]);
        }
      });
    this.setState({
      portObiSystemList: newPortObiArray,
      isLoading: false,
    });
  };

  handleClick = e => {
    if (this.boxRef.current.contains(e.target) || e.target.closest('.boxPortContainer')) {
      return;
    }
    this.props.onOutsideClick();
  };

  configObi = async reset => {
    const { boxDetails, port, portConfig, updatePortConfig } = this.props;
    const updatedPort = { ...port, e911Number: reset ? '' : boxDetails.e911Number };
    const { portKey } = updatedPort;
    boxDetails.Obis[updatedPort.obiIndex][portKey] = updatedPort;
    const portNumber = updatedPort.boxPortNumber.split(' ')[1];
    const body = {
      vpnAddress: boxDetails.vpnAddress,
      selectedPort: portNumber,
      e911Number: updatedPort.e911Number,
      obiObj: boxDetails.Obis[updatedPort.obiIndex],
    };
    const res = await portConfig(this.token, body);
    if (res) {
      this.setState({ portModal: false });
      updatePortConfig();
    }
  };

  onEditPropertyKeyPress = ev => {
    const keyCode = typeof ev.which === 'number' ? ev.which : ev.keyCode;
    const { name } = ev.target;
    const { value, checked } = ev.target;

    // Enter key

    if (name === 'e911Number') {
      this.configObi(!checked);
    } else {
      if (keyCode === 13 || name) {
        if (value === 'Custom') {
          setTimeout(() => {
            this.setState({ showError: false });
          }, 100);
          this.setState({ showModal: true });
        } else {
          this.updatedPort = {
            ...this.updatedPort,
            [name]: value,
          };
          for (const propName in this.updatedPort) {
            if (
              this.updatedPort[propName] === null ||
              this.updatedPort[propName] === undefined ||
              this.updatedPort[propName] === ''
            ) {
              delete this.updatedPort[propName];
            }
          }
          this.setState({
            editingProperty: null,
          });
          return;
        }
      }
      // Escape key
      if (keyCode === 27) {
        this.setState({
          editingProperty: null,
        });
      }
    }
  };

  onEditProperty = editingProperty => {
    this.setState({ editingProperty });
  };
  onForceFix = value => {
    this.setState({
      forceFix: value,
    });
  };

  onSelectNumber = ({ suggestion }, vmail) => {
    if (suggestion !== null) {
      this.props.editAssignedNumber(suggestion);
      this.props.assignRouteInfo(this.token, suggestion?._id);
      this.setState({
        selectedNumber: suggestion,
        showEditModal: true,
        vmail: !!vmail,
        previousType: suggestion.type,
      });
    }
  };

  onRemoveNumber = async () => {
    const updatedPortData = {
      ...this.props.port,
      ...this.updatedPort,
    };

    for (const propName in updatedPortData) {
      if (
        updatedPortData[propName] === null ||
        updatedPortData[propName] === undefined ||
        updatedPortData[propName] === ''
      ) {
        delete updatedPortData[propName];
      }
    }
    this.updatedPort = '';
    const unassignedNumId = updatedPortData.assignedNumberRef?._id
      ? updatedPortData.assignedNumberRef?._id
      : updatedPortData.assignedNumberRef;
    this.props.onPortUpdate(updatedPortData, unassignedNumId);
    this.setState({ modalStatus: false });
    this.updatedPort = '';
    this.props.onOutsideClick();
  };

  onAddNewNumber = (e, vmail) => {
    this.props.cancelAddNumber();
    this.props.editNumberCancel();
    this.setState({ showAddNumber: e, vmail: !!vmail });
  };
  updateSelectedPortBlockCallerId = newBlockCallerIdValue => {
    // Update the selectedPort prop value in the state
    this.setState(prevState => ({
      selectedPort: {
        ...prevState.selectedPort,
        blockCallerId: newBlockCallerIdValue,
      },
    }));
  };
  renderPortDetailsProperties = () => {
    return this.portDetailsProps.map(({ key, label, icon, editable, value, hidden }) => {
      return this.props.user.role === 'superAdmin' ||
        this.props.user.role === 'companyGroupAdmin' ||
        this.props.user.role === 'supportEngineer' ? (
        <PortProperty
          modifyStatus={this.state.modifyStatus}
          handleFwdToggle={() => {
            this.setState({ fwdModalState: true });
          }}
          onOutsideClick={() => this.props.onOutsideClick()}
          boxDetails={this.props.boxDetails}
          onAddNewNumber={this.onAddNewNumber}
          // assignedNumbers={this.props.assignedNumbers}
          onSelectNumber={this.onSelectNumber}
          onRemoveNumber={e => {
            this.setState({ modalStatus: e });
          }}
          deleteMode={this.props.deleteMode}
          user={this.props.user}
          key={key}
          prop={key}
          label={label}
          icon={icon}
          editable={editable}
          hidden={hidden}
          value={value}
          port={this.props.port}
          onEditProperty={this.onEditProperty}
          onEditPropertyKeyPress={this.onEditPropertyKeyPress}
          editing={this.state.editingProperty === key}
          forceFix={this.onForceFix}
          disabled={this.props.incomingFaxes?.isPendingFax}
          callWaitingToggle={this.callWaitingToggle}
        />
      ) : key !== 'remoteHost' && key !== 'remotePort' ? (
        <PortProperty
          modifyStatus={this.state.modifyStatus}
          onOutsideClick={() => this.props.onOutsideClick()}
          boxDetails={this.props.boxDetails}
          onAddNewNumber={this.onAddNewNumber}
          // assignedNumbers={this.props.assignedNumbers}
          onSelectNumber={this.onSelectNumber}
          onRemoveNumber={e => {
            this.setState({ modalStatus: e });
          }}
          deleteMode={this.props.deleteMode}
          user={this.props.user}
          key={key}
          prop={key}
          label={label}
          icon={icon}
          editable={editable}
          hidden={hidden}
          value={value}
          port={this.props.port}
          onEditProperty={this.onEditProperty}
          onEditPropertyKeyPress={this.onEditPropertyKeyPress}
          editing={this.state.editingProperty === key}
          forceFix={this.onForceFix}
        />
      ) : null;
    });
  };

  onCancel = () => {
    this.setState({ showModal: false });
  };

  onConfirm = () => {
    this.setState({ isLoading: true });
    const updatedPort = {
      ...this.props.port,
      serviceName: 'Custom',
    };
    for (const propName in updatedPort) {
      if (
        updatedPort[propName] === null ||
        updatedPort[propName] === undefined ||
        updatedPort[propName] === ''
      ) {
        delete updatedPort[propName];
      }
    }
    this.setState({
      editingProperty: null,
    });

    this.props.onUploadPortConfig(this.state.uplaodedFile, updatedPort);
  };

  saveUpdatedPort = async () => {
    const {
      boxDetails,
      updateAlarmProtocol,
      selectedProtocolBody,
      callerIdOverrideValue,
    } = this.props;
    const { typeChangeWarning } = this.state;
    const updatedPortData = {
      ...this.props.port,
      ...this.updatedPort,
      blockCallerId: this.props.blockCallerIdConfigValue,
      callerIdOverride: callerIdOverrideValue,
    };
    for (const propName in updatedPortData) {
      if (
        updatedPortData[propName] === null ||
        updatedPortData[propName] === undefined ||
        updatedPortData[propName] === ''
      ) {
        delete updatedPortData[propName];
      }
    }

    if (selectedProtocolBody?.operationMode === 'Live' && !typeChangeWarning) {
      const { selectedNumber } = this.state;

      const alarmProtocol = {
        ...selectedProtocolBody,
        numberID: selectedNumber?._id,
      };
      await updateAlarmProtocol(this.token, boxDetails?._id, alarmProtocol);
    }
    this.updatedPort = '';
    this.props.onPortUpdate(updatedPortData);
    setTimeout(() => {
      this.props.onOutsideClick();
    }, 500);
  };

  handleChangeUpload = e => {
    this.setState({ uplaodedFile: e.target.files[0] });
  };

  toggle = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  selectRoute = async (id, body, update = true) => {
    this.props.updateNumberRoute(id, body, true);
  };

  onHistoryCall = async () => {
    const { port, boxDetails, getPortCallHistory } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const historyCalls = await getPortCallHistory(this.token, boxDetails?._id, portNumber);
    if (historyCalls.portCallHistory === undefined) {
      toast.error('CALL HISTORY COULD NOT BE FETCHED');
    } else if (historyCalls.portCallHistory === 'CALL HISTORY COULD NOT BE FETCHED') {
      toast.error('CALL HISTORY COULD NOT BE FETCHED');
    } else if (historyCalls.portCallHistory === '' || historyCalls.portCallHistory === null) {
      toast.error('No call history found.');
    } else {
      const portNumber = port.boxPortNumber.split(' ');
      const newArray = [];
      if (
        historyCalls.portCallHistory.CallHistoryFile === '' ||
        historyCalls.portCallHistory === ''
      ) {
        toast.error('No call history found.');
      } else {
        if (!Array.isArray(historyCalls?.portCallHistory?.CallHistoryFile?.CallHistory)) {
          historyCalls.portCallHistory.CallHistoryFile.CallHistory = [
            historyCalls.portCallHistory.CallHistoryFile.CallHistory,
          ];
        }
        historyCalls.portCallHistory.CallHistoryFile.CallHistory.map(item => {
          item.Event.map(itemInner => {
            if (portNumber[1] % 2 === 1) {
              if (itemInner.e0 === 'From PH1' || itemInner.e1 === 'To PH1') {
                newArray.push(item);
              }
            } else if (itemInner.e0 === 'From PH2' || itemInner.e1 === 'To PH2') {
              newArray.push(item);
            }
          });
        });
        if (!newArray.length) toast.error(`No calls found for port ${portNumber[1]}`);
        this.setState({
          historyPortCall: newArray,
          showHistoryModal: !!newArray.length,
        });
      }
    }
  };

  onPortConfigure = async () => {
    const { getPortValues, port, boxDetails } = this.props;
    const portIdx = port.boxPortNumber.split(' ')[1];
    const obiId = getObiData(port.boxPortNumber, boxDetails, '_id');
    const values = portIdx % 2 === 0 ? evenValues : oddValues;
    this.setState({ loadingConfig: true });
    const res = await getPortValues(this.token, obiId, values);
    if (res) {
      this.setState({
        settings: res?.data?.settings,
        settingsValidationRules: res?.validationRules,
        showPortConfigModal: !!res?.data?.settings,
      });
    }
    this.setState({ loadingConfig: false });
  };

  validateNumber = async () => {
    const { port, enableAction } = this.props;
    const formattedNumber = parsePhoneNumberFromString(this.state.fwdNumber, 'US');

    if (formattedNumber && formattedNumber.country === 'US') {
      const body = {
        ...port?.assignedNumberRef,
        isForwarded: true,
        forwardNumbers: [formattedNumber?.number],
      };
      const response = await this.updateFwdNumber(body);
      if (response) {
        // [Action] - Add
        enableAction(`Add fwd number ${this.state.fwdNumber} from port`);
      }
    } else {
      toast.error('Invalid Number');
    }
  };

  removeFwdNumber = async () => {
    const { port, disableAction } = this.props;
    const body = {
      ...port?.assignedNumberRef,
      isForwarded: false,
      forwardNumbers: [],
    };
    const response = this.updateFwdNumber(body);
    if (response) {
      // [Action] - Delete
      disableAction(`remove fwd number ${this.state.fwdNumber} from port`);
    }
  };

  updateFwdNumber = async body => {
    const { boxDetails, updateNumber, onOutsideClick, getEpikBoxData } = this.props;

    const response = await updateNumber(this.token, body);
    await getEpikBoxData(this.token, boxDetails?._id);

    this.setState({ fwdModalState: false });
    this.props.onOutsideClick();
    return response;
  };

  monitorToggle = async () => {
    this.setState({ isContainerLoading: true });
    const { port, obiRebootRequired, boxDetails, addNote } = this.props;
    const { monitor } = this.state;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;
    const portCheck = portNumber % 2 === 0 ? 'port2' : 'port1';
    const body = {
      [portCheck]: { ...port, monitored: !monitor },
    };
    const response = await obiRebootRequired(this.token, obiId, body);
    if (response) {
      const message = body[portCheck]?.monitored === true ? 'enabled' : 'disabled';
      const obj = {
        note: `Monitor ${message} on ${port.boxPortNumber}`,
        type: 'system',
      };

      addNote(this.token, boxDetails._id, obj);
      this.onClose();
      this.setState({ monitor: !monitor });
      this.props.updatePortConfig();
    }
    this.setState({ isContainerLoading: false });
  };

  callWaitingToggle = async () => {
    console.log("cLL waiting value ", )
    this.setState({ isContainerLoading: true });
    const { port, obiRebootRequired, boxDetails, addNote } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;
    const portCheck = portNumber % 2 === 0 ? 'port2' : 'port1';
    const body = {
      [portCheck]: { ...port, callWaiting: !port?.callWaiting },
    };
    const response = await obiRebootRequired(this.token, obiId, body);
    if (response) {
      this.onClose();
      this.props.updatePortConfig();
    }
    this.setState({ isContainerLoading: false });
  };

  onClose = () => {
    this.updatedPort = '';
    this.props.onOutsideClick();
  };

  openSecurityModalForEnableDisablePortToggle = () =>
    this.setState(prev => ({
      ...prev,
      securityCheck: true,
      isOutboundSecuriety: false,
      isEnableDisablePortSecurity: true,
    }));

  openWarningModal = () =>
    this.setState(prev => ({
      ...prev,
      warningModal: true,
    }));

  closeWarningModal = () =>
    this.setState(prev => ({
      ...prev,
      warningModal: false,
      typeChangeWarning: false,
      isContainerLoading: false,
    }));

  closeWarningModalAndOpenSecurityModal = () => {
    this.closeWarningModal();
    this.openSecurityModalForEnableDisablePortToggle();
  };

  resetSecurityModalSettings = () =>
    this.setState(prev => ({
      ...prev,
      isOutboundSecuriety: false,
      isEnableDisablePortSecurity: false,
    }));

  getObiDataForEnablingDisablingPort = () => {
    const { port, boxDetails } = this.props;

    const { disabled } = this.state;

    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;

    // if mode is disabled then i will send api for enabled mode and vice versa
    const mode = disabled ? eDisableEnableAction.ENABLE : eDisableEnableAction.DISABLE;
    return {
      obiId,
      port: portNumber,
      boxId: boxDetails?._id,
      mode,
    };
  };

  closeSecurityModal = () => {
    this.setState(prev => ({ ...prev, securityCheck: false }));
  };

  refreshBoxData = async () => {
    const { boxDetails, getEpikBoxData } = this.props;
    await getEpikBoxData(this.token, boxDetails?._id);
    this.closeSecurityModal();
  };

  showErrorToaster = () => {
    toast.info(PORT_IS_REBOOTING);
  };

  enableDisableToggle = async () => {
    const { enableDisablePort } = this.props;
    const { enableDisableLastUpdatedTime } = this.state;

    this.resetSecurityModalSettings();

    const payload = this.getObiDataForEnablingDisablingPort();

    let minutesRelativeToLastChangedTime = DEFAULT_VALID_TIME_FOR_ENABLE_DISABLE_PORT;
    if (enableDisableLastUpdatedTime) {
      minutesRelativeToLastChangedTime = utils.getTimeDifferenceInMinutes(
        enableDisableLastUpdatedTime,
      );
    }

    console.info({ minutesRelativeToLastChangedTime, enableDisableLastUpdatedTime });

    if (minutesRelativeToLastChangedTime < 3) {
      this.showErrorToaster();
      this.closeSecurityModal();
      return;
    }

    const updatedTime = await enableDisablePort(payload);

    if (!updatedTime) {
      this.closeSecurityModal();
      return;
    }

    await this.refreshBoxData();

    const { mode } = payload;
    const updatedValue = mode === eDisableEnableAction.DISABLE;

    this.setState(prev => ({
      ...prev,
      disabled: updatedValue,
      portEnableDisableToggle: updatedValue,
      enableDisableLastUpdatedTime: updatedTime,
      portRebot: false
    }));
    await this.onPortStatus();
    await this.onObiSystemStatus()
  };

  outboundToggle = async () => {
    const { outbound } = this.state;
    this.setState({
      securityCheck: false,
      isOutboundSecuriety: false,
      isEnableDisablePortSecurity: false,
    });
    const { port, boxDetails, boundRemoveNumber, getEpikBoxData } = this.props;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;
    if (outbound) {
      const body = {
        port: `port${portNumber}`,
        obiId,
      };
      const res = await boundRemoveNumber(this.token, boxDetails?._id, body);
      if (res) this.setState({ outbound: false });
      await getEpikBoxData(this.token, boxDetails?._id);
    } else {
      this.setState({ outbound: true });
    }
  };

  onOutboundChange = e => {
    const { target } = e;
    if (!isNaN(target.value)) {
      this.setState({ outboundNumber: target.value });
    }
  };
  onOutboundNumber = async () => {
    const { port, boxDetails, boundForwardNumber, getEpikBoxData } = this.props;
    const { outboundNumber } = this.state;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const checkObi = Math.ceil(portNumber / 2 - 1);
    const obiId = boxDetails.Obis[checkObi]?._id;
    if (outboundNumber) {
      const body = {
        port: `port${portNumber}`,
        number: outboundNumber,
        obiId,
      };
      this.setState({ outboundNumberBtnLoading: true });
      await boundForwardNumber(this.token, boxDetails?._id, body);
      await getEpikBoxData(this.token, boxDetails?._id);
      this.setState({ outboundNumberBtnLoading: false });
    } else {
      toast.error('Invalid Number');
    }
  };

  updateNumberAddress = async e => {
    const { numbers, port, updateAddress, clearAddress, boxDetails, addNote } = this.props;
    const numbersDB = numbers?.allNumbers?.length ? numbers?.allNumbers : [numbers?.numberByID];
    const numberDetails = numbersDB?.filter(
      number => number?.number === port?.assignedNumber,
    );
    const updatedAddress = await updateAddress(this.token, numberDetails[0]?._id, e);
    clearAddress();
    if (updatedAddress?.statusCode === '200') {
      const message =
        port.e911Enabled === true || port.e911Enabled === 'true' ? 'updated' : 'enabled';
      const obj = {
        note: `e911 ${message} on ${port.boxPortNumber}`,
        type: 'system',
      };
      addNote(this.token, boxDetails._id, obj);
      this.postE911Update(port?.assignedNumber, true);
    }
    this.setState({ assignedE911Number: false });
  };

  onRemoveAddress = async () => {
    const { selectedNumberId } = this.state;
    const { removeNumberAddress, port, box, addNote } = this.props;
    const withoutPlusOne = port?.assignedNumber.split('+1');
    const body = { dn: withoutPlusOne[1] };
    const remove = await removeNumberAddress(this.token, selectedNumberId, body);
    if (remove?.statusCode === '200') {
      const obj = {
        note: `e911 removed from ${port.boxPortNumber}`,
        type: 'system',
      };
      addNote(this.token, box._id, obj);
      this.postE911Update(box?.e911Number, false);
    }
    this.setState({ assignedE911Number: false });
    this.onClose();
  };

  postE911Update = async (number, status) => {
    const { updateObi, portConfig, getEpikBoxData, port, box } = this.props;
    const updatedPort = {
      ...port,
      e911Number: number,
      e911Enabled: status,
    };
    const portNumber = updatedPort.boxPortNumber.split(' ')[1];
    const body = {
      vpnAddress: box.vpnAddress,
      selectedPort: portNumber,
      e911Number: updatedPort.e911Number,
      obiObj: box.Obis[updatedPort.obiIndex],
    };
    const foundObi = box.Obis.find(obi => {
      return (
        (obi.port1 && obi.port1.boxPortNumber === updatedPort.boxPortNumber) ||
        (obi.port2 && obi.port2.boxPortNumber === updatedPort.boxPortNumber)
      );
    });
    if (foundObi) {
      if (foundObi?.port1?.boxPortNumber === updatedPort.boxPortNumber) {
        const { connected, ...updatedNew } = updatedPort;
        foundObi.port1 = updatedNew;
      } else {
        const { connected, ...updatedNew } = updatedPort;
        foundObi.port2 = updatedNew;
      }
    }
    const changedPort = portNumber % 2 === 0 ? 'port2' : 'port1';
    const updatedObi = { ...foundObi, changedPort };
    await updateObi(
      this.token,
      updatedObi,
      box.epikBoxUser._id,
      (updatedPort.assignedNumberRef && updatedPort.assignedNumberRef._id) ||
      updatedPort.assignedNumberRef,
    );
    await portConfig(this.token, body);
    await getEpikBoxData(this.token, box?._id);
  };

  onE911Update = () => {
    const { assignedE911Number } = this.state;
    this.setState({ assignedE911Number: !assignedE911Number });
  };

  updateAdvanceModemConfig = async selectedPortType => {
    const {
      boxDetails,
      selectedPort,
      advModemConfigValue,
      updateAdvanceModemConfigurations,
      addNote,
    } = this.props;
    const usedToType = ['alarm', 'fireAlarm', 'modem', 'secureEntry', 'elevator'];

    if (!usedToType.includes(selectedPortType)) return;

    const { _id: bId } = boxDetails;
    const port = selectedPort.portKey
      .split(`port`)
      .pop()
      .trim();
    const { Obis } = boxDetails;
    const obiPort = `${selectedPort.portKey}`;

    const findSelectedObi = obi => {
      return selectedPort?.assignedNumberRef?._id === obi[obiPort]?.assignedNumberRef?._id;
    };

    const isObiSelected = Obis.find(findSelectedObi);
    if (!isObiSelected) return;

    if (
      (!isObiSelected[obiPort]?.advancedModemConfiguration && !advModemConfigValue) ||
      isObiSelected[obiPort]?.advancedModemConfiguration === advModemConfigValue
    )
      return;

    const payload = {
      obiId: isObiSelected._id,
      mode: advModemConfigValue,
      port,
      lineType: selectedPortType,
    };

    const result = await updateAdvanceModemConfigurations(this.token, bId, payload);

    if (result) {
      const message = advModemConfigValue === true ? 'enabled' : 'disabled';
      const obj = {
        note: `Advanced Modem Configuration ${message} on ${selectedPort.boxPortNumber}`,
        type: 'system',
      };
      addNote(this.token, bId, obj);
    }
  };

  onConfirmSave = async () => {
    const { selectedNumberType, user, saveNumber, getSelectedPortModal, updateNumberRouteAndTrunk, boxDetails } = this.props;
    const { previousType, vmail } = this.state;
    // [Action]- Edit Old
    await getSelectedPortModal('edit-old');
    // [Action]- All Bulk Actions
    if (selectedNumberType === 'unassigned') {
      toast.error('Line type is required');
    } else {
      const selectedPortType = selectedNumberType;
      const previousPortType = previousType;
      if (
        (previousPortType === 'fireAlarm' || previousPortType === 'alarm') &&
        (selectedPortType !== 'alarm' && selectedPortType !== 'fireAlarm')
      ) {
        if (this.state.alarmRelay?.operationMode === 'Live') {
          this.setState({ typeChangeWarning: true, isContainerLoading: true });
        } else {
          this.setState({ isContainerLoading: true });
          this.updateTypeAndRemoveAPRSettings();
        }
      } else {
        await saveNumber('vmailType');
        if (user.role !== 'admin' && !vmail) {
          this.saveUpdatedPort();
          await this.updateAdvanceModemConfig(selectedPortType);
          await updateNumberRouteAndTrunk(this.token, boxDetails._id)
        } else {
          this.props.onOutsideClick();
        }
      }
    }
  };

  updateTypeAndRemoveAPRSettings = async () => {
    const { boxDetails, removeAlarmProtocolSettings, saveNumber, user } = this.props;
    const { selectedNumber, vmail } = this.state;
    const { _id, alarmRelayInfo } = selectedNumber;

    await saveNumber('vmailType');
    if (user.role !== 'admin' && !vmail) {
      this.saveUpdatedPort();
      await this.updateAdvanceModemConfig();
    } else {
      this.props.onOutsideClick();
    }

    const alarmProtocol = {
      alarmRelayInfo,
      _id,
    };

    await removeAlarmProtocolSettings(this.token, boxDetails?._id, alarmProtocol);

    this.setState({
      typeChangeWarning: true,
      isContainerLoading: false,
    });
  };

  render() {
    const {
      port,
      onConfigResp,
      boxDetails,
      gateways,
      user,
      box,
      updatePortConfig,
      selectedNumberType,
      assignAction,
      sendBulkActionsToApi,
      selectedNumberPro,
      addressModalData,
      getSelectedPortModal,
      incomingFaxes,
      getEpikBoxData
    } = this.props;

    const {
      historyPortCall,
      portObiSystemList,
      isLoading,
      showPortConfigModal,
      loadingConfig,
      settings,
      settingsValidationRules,
      vmail,
      trunkOptions,
      selectedTrunkOption,
      portPhysicalData,
      portBtnLoading,
      outbound,
      outboundNumber,
      monitor,
      disabled,
      outboundNumberBtnLoading,
      historyStatus,
      isContainerLoading,
      selectedNumber,
      alarmRelay,
      loadingApr,
      warningModal,
      typeChangeWarning,
    } = this.state;
    const portNumber = port.boxPortNumber.replace(/[^0-9]/g, '');
    const portCheck = portNumber % 2 === 0 ? 'Port 2' : 'Port 1';
    const portEnableDisabledClass = disabled
      ? 'd-flex red-disabled'
      : 'd-flex red-container brighter';
    const historyButton = (
      <div>
        {utils.showActivate(port, boxDetails, user) ? <ActivateButton port={port} disabled={incomingFaxes?.isPendingFax} /> : null}
        {!box?.myEpik && !isAdminRole(user.role) ? (
          <Button
            disabled={loadingConfig || incomingFaxes?.isPendingFax}
            color="primary"
            style={{ marginRight: '10px' }}
            onClick={this.onPortConfigure}
          >
            {loadingConfig ? <SpinnerCircles /> : 'Port Configuration'}
          </Button>
        ) : null}
        <Button color="primary" onClick={this.onHistoryCall} disabled={historyStatus || incomingFaxes?.isPendingFax}>
          Port Call History
        </Button>
      </div>
    );
    return (
      <div id="selected-port-details" ref={this.boxRef}>
        <PortConfigModal
          port={port}
          updatePortConfig={updatePortConfig}
          boxDetails={boxDetails}
          settings={settings}
          settingsValidationRules={settingsValidationRules}
          isOpen={showPortConfigModal}
          refresh={this.onPortConfigure}
          isClose={() => this.setState({ showPortConfigModal: false })}
        />
        <Modal isOpen={this.state.showModal}>
          <ModalHeader>Service Name</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Configuration File:</Label>
              <Input
                type="file"
                accept=".config"
                onChange={this.handleChangeUpload}
                name="imagePage"
              />
            </FormGroup>
            {this.state.showError ? (
              onConfigResp.omitted && Object.keys(onConfigResp.omitted).length ? (
                <div>
                  <Dropdown isOpen={this.state.dropdownOpen} toggle={() => this.toggle()}>
                    <DropdownToggle caret>Click To see Omitted Values</DropdownToggle>
                  </Dropdown>

                  <div style={{ padding: '20px' }} hidden={!this.state.dropdownOpen}>
                    {Object.keys(onConfigResp.omitted).join(', ')}
                  </div>
                </div>
              ) : null
            ) : null}
          </ModalBody>
          <ModalFooter>
            <Button outline color="secondary" onClick={this.onCancel}>
              Cancel
            </Button>
            <Button color="primary" disabled={this.state.isLoading} onClick={this.onConfirm}>
              {!this.state.isLoading ? 'Submit' : 'Loading'}
            </Button>
          </ModalFooter>
        </Modal>

        <Modal className="medium-box-modal" isOpen={this.state.portModal}>
          <ModalHeader close={historyButton}>
            {port?.assignedNumberRef?.type || 'Unassigned'}
          </ModalHeader>
          <ModalBody>
            {isContainerLoading && <Spinner />}
            {incomingFaxes?.isPendingFax && <p className=' error-message error-blink '>{PENDING_FAX_AVAILABLE}</p>}
            <Row>
              <Col md={6}>{this.renderPortDetailsProperties()}</Col>
              <Col md={6}>
                <div className="obi-status-view">
                  <FormGroup row>
                    <Label for="showCallRecording" sm={8}>
                      Original Provisioned Date:
                    </Label>
                    <Col md={12}>
                      {utils.getDateTimeFormat(this.props.port?.provisionDate, 'both')}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Label for="showCallRecording" sm={8}>
                      Last Updated:
                    </Label>
                    <Col md={12}>
                      {utils.getDateTimeFormat(this.props.port?.updatedOn, 'both')}
                    </Col>
                  </FormGroup>
                  <FormGroup row>
                    <Col md={12}>
                      <div style={{ backgroundColor: '#888888' }}>
                        <p
                          style={{
                            margin: '2px 0px 2px 0px',
                            color: '#ffffff',
                            fontWeight: 'bold',
                          }}
                        >
                          Port Status:
                        </p>
                      </div>
                      {
                        !this.state.portRebot ?
                          !!Object.keys(portPhysicalData).length &&
                        Object.entries(portPhysicalData)?.map(([key, value]) => {
                          if (key.includes("disabled")) return null
                          return (
                            <div className="port-row">
                              <p style={{ margin: '0px' }}>{utils.toTitleCase(key)}: </p>
                              <p style={{ margin: '0px' }}>{value}</p>
                            </div>
                          );
                        })
                          : <div className='d-flex flex-column'>
                            <p>{PORT_IS_REBOOTING}</p>
                            <div className="loading-btn-spinner" style={{ alignSelf: 'center' }} />
                          </div>
                      }
                    </Col>
                    <Col md={12} className="refresh-port">
                      <Button color="primary" onClick={this.onPortStatus} disabled={portBtnLoading}>
                        {!portBtnLoading ? 'Refresh' : <div className="loading-btn-spinner" />}
                      </Button>
                    </Col>
                  </FormGroup>

                  {portObiSystemList.length > 0 &&
                    portObiSystemList.map(item => {
                      const itemObi = Object.values(item);
                      return (
                        <FormGroup row>
                          <Col md={12}>
                            <div>
                              <div style={{ backgroundColor: '#888888' }}>
                                <p
                                  style={{
                                    margin: '2px 0px 2px 0px',
                                    color: '#ffffff',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {item.placeHolder}:
                                </p>
                              </div>
                              {itemObi.map(innerItem => {
                                return (
                                  innerItem !== item.placeHolder && (
                                    <p style={{ margin: '0px' }}>{innerItem}</p>
                                  )
                                );
                              })}
                            </div>
                          </Col>
                        </FormGroup>
                      );
                    })}

                  <Button
                    color="primary"
                    onClick={this.onObiSystemStatus}
                    disabled={!(portObiSystemList.length > 0 && !isLoading)}
                    style={{ float: 'right' }}
                  >
                    {!isLoading ? 'Refresh EPI' : <div className="loading-btn-spinner" />}
                  </Button>
                </div>
                <FormGroup row style={{ marginBottom: '0px ' }}>
                  <Label for="name" sm={8} className="d-flex">
                    Monitor:
                    <sup>
                      <InfoPopup id="port-monitor" text={TOOLTIPS_TEXT.MONITOR} />
                    </sup>
                  </Label>
                  <Col md={12} className="d-flex">
                    <Toggle value={monitor} onToggle={this.monitorToggle} disabled={incomingFaxes?.isPendingFax} />
                    <span className="ml-2">{this.props.port.boxPortNumber}</span>
                  </Col>
                </FormGroup>
                {!boxDetails.myEpik && (
                  <FormGroup style={{ marginBottom: '0px ' }} row>
                    <Label for="name" sm={12} className="d-flex">
                      Outbound Number Override:
                      <sup>
                        <InfoPopup id="outbound-number" text={TOOLTIPS_TEXT.OUTBOUND_OVERRIDE} />
                      </sup>
                    </Label>
                    <Col md={12} className="d-flex">
                      <Toggle
                        value={outbound}
                        disabled={!outbound || incomingFaxes?.isPendingFax}
                        onToggle={() => {
                          return !isAdminRole(user.role)
                            ? this.setState({ securityCheck: true, isOutboundSecuriety: true })
                            : null;
                        }}
                      // onToggle={this.outboundToggle}
                      />
                    </Col>
                    {!isAdminRole(user.role) && !outbound && (
                      <Col md={12} className="d-flex flex-row p-3">
                        <Input
                          placeholder="Please specify"
                          required
                          type="text"
                          name="outboundNumber"
                          value={outboundNumber}
                          maxLength={10}
                          onChange={this.onOutboundChange}
                        />
                        <Button
                          color="primary"
                          disabled={outboundNumberBtnLoading || incomingFaxes?.isPendingFax}
                          onClick={this.onOutboundNumber}
                        >
                          {!outboundNumberBtnLoading ? (
                            'Submit'
                          ) : (
                            <div className="loading-btn-spinner" />
                          )}
                        </Button>
                      </Col>
                    )}
                  </FormGroup>
                )}
                {port?.assignedNumberRef?.number && (
                  <>
                    <FormGroup style={{ marginBottom: '0px ' }} row>
                      <Label for="name" sm={8} style={{ color: '#dc3545' }} className="d-flex">
                        {/* Port: {portPhysicalData.disabled ? 'Disabled' : 'Enabled'} */}
                        Port: {!(this.state.portEnableDisableToggle) ? 'Enabled' : 'Disabled'}
                        <sup>
                          <InfoPopup id="port-enabled" text={TOOLTIPS_TEXT.PORT_ENABLE} />
                        </sup>
                      </Label>
                      <Col md={12}>
                        <Toggle
                          // value={!portPhysicalData.disabled}
                          value={!(this.state.portEnableDisableToggle)}
                          redSides
                          onToggle={() => {
                            return !isAdminRole(user.role) ? this.openWarningModal() : null;
                          }}
                          disabled={portBtnLoading || incomingFaxes?.isPendingFax}
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup style={{ marginBottom: '0px ' }} row>
                      {loadingApr ? (
                        <div className="d-flex">
                          <Label for="name" sm={8} style={{ color: '#dc3545' }}>
                            Checking APR...
                          </Label>
                          <SpinnerCircles red />
                        </div>
                      ) : (
                        alarmRelay?.operationMode === 'Live' && (
                          <Label
                            for="name"
                            sm={12}
                            style={{ color: '#dc3545', fontWeight: 'bold' }}
                          >
                            APR is Enabled
                          </Label>
                        )
                      )}
                    </FormGroup>
                  </>
                )}
                {!isAdminRole(user.role) && (
                  <>
                    <FormGroup row style={{ marginBottom: '0px' }}>
                      <Label for="name" md={12} className="pr-0">
                        Use Port Assigned Number for e911:
                      </Label>
                    </FormGroup>
                    <Row className="ml-1">
                      <Button color="primary" onClick={this.onE911Update} disabled={incomingFaxes?.isPendingFax}>
                        {port.e911Enabled ? 'Update/Remove Address' : 'Use Port e911'}
                      </Button>
                    </Row>
                  </>
                )}
              </Col>
            </Row>
            {!box.myEpik && (
              <Row
                style={{ marginLeft: '0px', marginRight: '30px' }}
                hidden={
                  port?.assignedNumberRef?.type !== 'modem' &&
                  port?.assignedNumberRef?.type !== 'faxStandard' &&
                  port?.assignedNumberRef?.type !== 'fireAlarm' &&
                  port?.assignedNumberRef?.type !== 'alarm'
                }
              >
                <Col md={{ size: '6' }}>
                  <InputGroup style={{ flexWrap: 'nowrap' }}>
                    <InputGroupAddon
                      addonType="prepend"
                      style={{ height: 'calc(1.5em + 0.75rem + 2px)' }}
                    >
                      <InputGroupText>
                        <i class="fas fa-cog"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <DropdownSelect
                      disabled={isAdminRole(this.props.user.role) || incomingFaxes?.isPendingFax}
                      selectedOption={selectedTrunkOption}
                      options={trunkOptions}
                      onSelect={({ value, label }) => {
                        this.setState({ securityCheck: true });
                        this.setState({
                          selectedTrunkOption: value,
                          selectedTrunkLabel: label,
                          trunkOptions: trunkOptions.filter(item => item.value !== '1'),
                        });
                      }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            )}
            {/* </div> */}
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.onClose} color="primary">
              Close
            </Button>
            {this.state.forceFix && (
              <Button color="danger" onClick={this.onForceFixBtn}>
                Force Fix
              </Button>
            )}
          </ModalFooter>
        </Modal>
        <AddSecurityCodeModal
          isOpen={this.state.securityCheck}
          onCancel={() => {
            this.setState({
              securityCheck: !this.state.securityCheck,
              wrongSecurity: !this.state.wrongSecurityCode,
              isOutboundSecuriety: false,
              isEnableDisablePortSecurity: false,
            });
          }}
          onConfirm={() => {
            const { isOutboundSecuriety, isEnableDisablePortSecurity } = this.state;
            if (isOutboundSecuriety) {
              this.outboundToggle();
            }
            if (isEnableDisablePortSecurity) {
              this.enableDisableToggle();
            } else {
              this.confirmCheck();
            }
          }}
          trunkCode={!this.state.isOutboundSecuriety}
          enableDisablePortCode={!!this.state.isEnableDisablePortSecurity}
          multiCode={this.state.isOutboundSecuriety}
          // modalName='outboundremoval'
          featureName={
            this.state.isEnableDisablePortSecurity ? 'enableDisablePortCode' :
              this.state.isOutboundSecuriety ? "outBoundSecuriety" : 'trunkCode'
          }
        />

        {/* WARNING MODAL WHEN PORT IS DISABLED/ENABLED */}
        <ConfirmationModal
          isOpen={warningModal || typeChangeWarning}
          onCancel={this.closeWarningModal}
          onConfirm={
            warningModal
              ? this.closeWarningModalAndOpenSecurityModal
              : this.updateTypeAndRemoveAPRSettings
          }
          bodyText={warningModal ? CONFIRMATION_MODAL_BODY : CONFIRMATION_TYPE_CHANGE}
          confirmBtnText="Continue"
        />

        {/* <--- History Call Modal ---> */}

        <Modal isOpen={this.state.showHistoryModal}>
          <ModalHeader>Port Call History</ModalHeader>
          <ModalBody style={{ height: '400px', overflow: 'auto' }}>
            {historyPortCall.length > 0 &&
              historyPortCall.map(item => {
                return (
                  <div>
                    <div style={{ backgroundColor: '#888888' }}>
                      <p
                        style={{ margin: '2px 0px 2px 0px', color: '#ffffff', fontWeight: 'bold' }}
                      >
                        {item['-time']} date:
                        {item['-date']}
                      </p>
                    </div>
                    {item.Event.map(item => {
                      return (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex' }}>
                            <p style={{ margin: '0px 5px 0px 0px', color: 'blue' }}>
                              {item['-time']}
                            </p>
                            <p style={{ margin: '0px' }}>{item.e0}</p>
                          </div>
                          <p style={{ margin: '0px' }}>{item.e1}</p>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </ModalBody>
          <ModalFooter>
            <Button
              outline
              color="secondary"
              onClick={() => {
                this.setState({ showHistoryModal: false });
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>

        {/* <--- End History Call Modal ---> */}
        <EditBoxNumberModal
          selectRoute={(id, body, update = false) => {
            this.selectRoute(id, body, update);
          }}
          vmail={vmail}
          gateways={gateways}
          boxDetails={boxDetails}
          selectedNumber={this.state.selectedNumber}
          isOpen={this.state.showEditModal}
          onCancel={() => {
            this.setState({ showEditModal: false });
          }}
          onConfirm={this.onConfirmSave}
          onRemoveNumber={e => {
            this.setState({ modalStatus: e });
          }}
        />
        <AddBoxNumberModal
          selectRoute={(id, body, update = false) => {
            this.selectRoute(id, body, update);
          }}
          gateways={gateways}
          vmail={vmail}
          boxDetails={boxDetails}
          isOpen={this.state.showAddNumber}
          onCancel={() => this.onAddNewNumber(false)}
          onConfirm={async editMode => {
            await getSelectedPortModal('add-new');
            // [Action]- All Bulk Actions
            if (selectedNumberType === 'unassigned') {
              toast.error('Line type is required');
            } else {
              if (editMode) {
                await this.props.saveNumber(vmail);
                if (!vmail) {
                  this.saveUpdatedPort();
                } else {
                  this.props.onOutsideClick();
                }
              } else {
                this.props.onAddNumber();
                this.onAddNewNumber(false);
              }
            }
          }}
          onEditPropertyKeyPress={this.onEditPropertyKeyPress}
          port={port}
        />

        <E911AddressModal
          onRemoveAddress={this.onRemoveAddress}
          isOpen={this.state.assignedE911Number}
          selectedNumberTitle={port?.assignedNumber}
          data={addressModalData}
          onCancel={() => {
            this.setState({ assignedE911Number: false });
            this.props.clearAddress();
            this.onClose();
          }}
          onUpdate={async e => {
            await this.updateNumberAddress(e);
            await this.getNumberAddress();
            await getEpikBoxData(this.token, boxDetails._id);
            this.onClose();
          }}
          port={port}
        />

        <DeleteModal
          data="remove"
          isOpen={this.state.modalStatus}
          onCancel={() => this.setState({ modalStatus: false })}
          onConfirm={this.onRemoveNumber}
        />

        <CustomModal
          header="Forward Number"
          onConfirm={this.state.fwdCheck ? this.validateNumber : false}
          isOpen={this.state.fwdModalState}
          onCancel={() => this.setState({ fwdModalState: false })}
        >
          <ForwardNumber
            fwdCheck={this.state.fwdCheck}
            fwdNumber={this.state.fwdNumber}
            onDeleteFwdNumber={this.removeFwdNumber}
            handleChange={e => {
              this.setState({ fwdNumber: e });
            }}
          />
        </CustomModal>
      </div>
    );
  }
}

SelectedPortPanel.propTypes = {
  port: PropTypes.object,
  onPortUpdate: PropTypes.func,
};

const mapStateToProps = state => ({
  onConfigResp: state.AppState.obis.unassignedObis.obiResp || null,
  assignedNumbers: state.AppState.obis.assignedNumbers || [],
  user: state.AppState.user,
  deleteMode: state.AppState.deleteMode,
  gateways: state.AppState.provisioning.gateways,
  obiSystemStatus: state.AppState.boxDetails.obiSystemStatus,
  box: state.AppState.boxDetails.box,
  selectedNumberType: state.UIState.numbers.editNumber.type,
  addressModalData: state.AppState.provisioning.address,
  numbers: state.AppState.numbers,
  selectedNumberPro: state.AppState.numbers.numberByID,
  selectedProtocolBody: state.UIState.epikBoxes.selectedProtocolBody,
  advModemConfigValue: state.AppState.boxDetails.advModemConfigValue,
  callerIdOverrideValue: state.AppState.boxDetails.callerIdOverrideValue,
  selectedPort: state.UIState.epikBoxDetails.selectedPort,
  selectedObi: state.UIState.epikBoxDetails.selectedObi,
  incomingFaxes: state.AppState.faxes.incomingFaxes,
  blockCallerIdConfigValue:state.AppState.boxDetails.blockCallerIdConfigValue,
});

const mapDispatchToProps = dispatch => ({
  enableDisablePort: payload => dispatch(enableDisablePort(payload)),
  getNumberByID: (token, id) => dispatch(getNumberByID(token, id)),
  getAlarmRelay: (token, bid, portNumber) => dispatch(getAlarmRelay(token, bid, portNumber)),
  getSelectedPortModal: type => dispatch(getSelectedPortModal(type)),
  editAssignedNumber: id => dispatch(editAssignedNumber(id)),
  getAddress: (token, numId) => dispatch(getAddress(token, numId)),
  removeNumberAddress: (token, id, body) =>
    dispatch(ProvisioningActions.removeNumberAddress(token, id, body)),
  obiRebootRequired: (token, id, payload) => dispatch(obiRebootRequired(token, id, payload)),
  getPortCallHistory: (token, bid, portNumber) =>
    dispatch(getPortCallHistory(token, bid, portNumber)),
  getObiSystemStatus: (token, bid, portNumber) =>
    dispatch(getObiSystemStatus(token, bid, portNumber)),
  getPhysicalStatus: (token, bid, portNumber) =>
    dispatch(getPhysicalStatus(token, bid, portNumber)),
  getGateways: token => dispatch(getGateways(token)),
  updateAddress: (token, numId, body) => dispatch(updateAddress(token, numId, body)),
  cancelAddNumber: () => dispatch(cancelAddNumber()),
  assignRouteInfo: (token, numId) => dispatch(assignRouteInfo(token, numId)),
  editNumberCancel: () => dispatch(editNumberCancel()),
  portConfig: (token, body) => dispatch(portConfig(token, body)),
  getPortValues: (token, obiId, values) => dispatch(getPortValues(token, obiId, values)),
  getAssignedNumbers: (token, cid, uid, priStatus) =>
    dispatch(getAssignedNumbers(token, cid, uid, priStatus)),
  updateNumber: (token, number) => dispatch(updateNumber(token, number)),
  forceFixNumber: (token, nid, bid) => dispatch(forceFixNumber(token, nid, bid)),
  getEpikBoxData: (token, boxId) => dispatch(getEpikBoxData(token, boxId)),
  selectPort: port => dispatch(selectBoxDetailsPort(port)),
  trunkPortConfig: (token, body) => dispatch(trunkPortConfig(token, body)),
  boundForwardNumber: (token, bid, body) => dispatch(boundForwardNumber(token, bid, body)),
  boundRemoveNumber: (token, bid, body) => dispatch(boundRemoveNumber(token, bid, body)),
  updateAlarmProtocol: (token, bid, body) => dispatch(updateAlarmProtocol(token, bid, body)),
  removeAlarmProtocolSettings: (token, bid, body) =>
    dispatch(removeAlarmProtocolSettings(token, bid, body)),
  assignAction: description => dispatch(assignAction(description)),
  unassignAction: description => dispatch(unassignAction(description)),
  enableAction: description => dispatch(enableAction(description)),
  disableAction: description => dispatch(disableAction(description)),
  sendBulkActionsToApi: () => dispatch(sendBulkActionsToApi()),
  clearAddress: () => dispatch(ProvisioningActions.clearAddress()),
  updateObi: (token, obi, epikBoxUser, numId) =>
    dispatch(updateEpikBoxObi(token, obi, epikBoxUser, numId)),
  addNote: (token, id, note) => dispatch(addNote(token, id, note)),
  updateAdvanceModemConfigurations: (token, bId, payload) =>
    dispatch(updateAdvanceModemConfigurations(token, bId, payload)),
  updateNumberRouteAndTrunk: (token, bid) =>
  dispatch(updateNumberRouteAndTrunk(token, bid)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectedPortPanel);
